import { ref } from "vue";

export const showAlertAuthBasket = ref(false);
export const showAlertAuthBasketTransition = ref(false);